import "./fonts.css";
import "./app.css";
import { bootToken, wantedTenant } from "./boot-token";
import { UI_LANGS, type UiLang } from "@imagora/contracts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadLanguage } from "./i18n";
import { ignoreHeightOnlyResizes } from "./lib/frame-resize";
import { sessionStore } from "./lib/runtime";
import { peekTokenHints } from "./lib/session";
import { createAppRouter } from "./routes/router";

if (window.parent !== window) ignoreHeightOnlyResizes(window);

const hints = bootToken ? peekTokenHints(bootToken) : {};
const browserLang = navigator.language.slice(0, 2) as UiLang;
const initialLang: UiLang = hints.lang ?? (UI_LANGS.includes(browserLang) ? browserLang : "en");

// Here and not in an effect: StrictMode runs effects twice, and a token can be exchanged only once.
void sessionStore.boot(bootToken, wantedTenant);

const gallery = import.meta.env.DEV ? () => import("./features/gallery/GalleryScreen") : undefined;
const previews = import.meta.env.DEV ? () => import("./components/previews/gallery/PreviewGallery") : undefined;
const router = createAppRouter({ gallery, previews });

void loadLanguage(initialLang).then((initialDictionary) => {
  const root = document.getElementById("root");
  if (!root) throw new Error("index.html has no #root");
  createRoot(root).render(
    <StrictMode>
      <App router={router} initialLang={initialLang} initialDictionary={initialDictionary} themeHint={hints.theme} />
    </StrictMode>,
  );
});
